import { OptionValue } from "@shared/Inputs/Dropdown";

export const categories: OptionValue[] = [
  { label: "Bone", value: "Bone" },
  { label: "Regular", value: "Regular" },
  { label: "Basic", value: "Basic" },
  { label: "Sub-prime", value: "Sub-prime" },
  { label: "Prime", value: "Prime" },
];
